// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h0[data-v-24b9746e]{font-size:3.5rem;font-weight:700}table td.nowrap[data-v-24b9746e],table th.nowrap[data-v-24b9746e]{width:1%;white-space:nowrap}table td.marker[data-v-24b9746e],table th.marker[data-v-24b9746e]{display:flex}table td.marker span[data-v-24b9746e],table th.marker span[data-v-24b9746e]{height:1.5rem;width:.35rem}", ""]);
// Exports
module.exports = exports;
